import {
  Sparkles,
  Droplets,
  Waves,
  Building2,
  ShieldCheck,
  Leaf,
  Layers,
} from "lucide-react";

export const COMPANY = {
  name: "Kilic Gebäudeservice",
  short: "Kilic",
  phoneDisplay: "+49 1525 6209968",
  phoneTel: "+4915256209968",
  whatsapp: "4915256209968",
  email: "info@kilic-gebaeudeservice.de",
  street: "Wilhelm-Wolters-Str. 170",
  city: "28309 Bremen",
  region: "Bremen & Umgebung",
  years: 20,
};

export const LOGO_URL = "/kilic-logo.png";
export const PHOTO_HOUSE =
  "https://customer-assets.emergentagent.com/job_43b03025-4ab2-4f4e-b802-82ecd60ef10a/artifacts/9b0dyy60_unnamed%20%282%29.webp";
export const PHOTO_WORK =
  "https://customer-assets.emergentagent.com/job_43b03025-4ab2-4f4e-b802-82ecd60ef10a/artifacts/jhvqopuf_unnamed%20%283%29.webp";

// Echte Projektfotos für die Galerie
export const GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/gcks38tl_WhatsApp%20Image%202026-07-05%20at%2016.55.12.jpeg",
    title: "Fassadenreinigung",
    cat: "Fassade",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/12z7h5zq_WhatsApp%20Image%202026-07-05%20at%2017.03.58.jpeg",
    title: "Wintergarten-Reinigung",
    cat: "Glasreinigung",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/bn8xijfx_WhatsApp%20Image%202026-07-05%20at%2017.07.41.jpeg",
    title: "Boden & PU-Versiegelung",
    cat: "Parkett & Boden",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/ad79hrgk_WhatsApp%20Image%202026-07-05%20at%2017.05.04.jpeg",
    title: "Parkett-Versiegelung",
    cat: "Parkett & Boden",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/nf04oq7c_WhatsApp%20Image%202026-07-05%20at%2017.17.30.jpeg",
    title: "Fenster & Glasfassade",
    cat: "Glasreinigung",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/mxq10p6k_WhatsApp%20Image%202026-07-05%20at%2013.00.28%20%289%29.jpeg",
    title: "Terrassenreinigung",
    cat: "Hochdruckreinigung",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/dgzssbtv_WhatsApp%20Image%202026-07-05%20at%2013.00.28%20%285%29.jpeg",
    title: "Terrasse & Pergola",
    cat: "Gartenpflege",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/1u1awt1j_WhatsApp%20Image%202026-07-05%20at%2013.00.28%20%288%29.jpeg",
    title: "Fenster & Fassade",
    cat: "Glasreinigung",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/j1s24y7l_WhatsApp%20Image%202026-07-05%20at%2013.00.28%20%284%29.jpeg",
    title: "Pflasterreinigung",
    cat: "Hochdruckreinigung",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/e8dhy2i2_WhatsApp%20Image%202026-07-05%20at%2013.00.28%20%2811%29.jpeg",
    title: "Solaranlagen-Reinigung",
    cat: "Spezialreinigung",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/p1h899l5_WhatsApp%20Image%202026-07-05%20at%2013.00.28%20%2810%29.jpeg",
    title: "Wintergarten & Glas",
    cat: "Glasreinigung",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/5pp89ta8_WhatsApp%20Image%202026-07-05%20at%2013.00.28%20%287%29.jpeg",
    title: "Einsatz in Bremen",
    cat: "Gebäudereinigung",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/rdp9exzm_WhatsApp%20Image%202026-07-05%20at%2013.00.28%20%286%29.jpeg",
    title: "Garten & Lounge",
    cat: "Gartenpflege",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_43b03025-4ab2-4f4e-b802-82ecd60ef10a/artifacts/9b0dyy60_unnamed%20%282%29.webp",
    title: "Fassade & Fenster",
    cat: "Glasreinigung",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_43b03025-4ab2-4f4e-b802-82ecd60ef10a/artifacts/jhvqopuf_unnamed%20%283%29.webp",
    title: "Fassadenreinigung",
    cat: "Hochdruckreinigung",
  },
];

export const SERVICES = [
  {
    id: "glasreinigung",
    title: "Glasreinigung",
    icon: Sparkles,
    text: "Unsere Glasreinigung sorgt für kristallklare Fenster, die Ihr Zuhause in neuem Glanz erstrahlen lassen.",
    image:
      "https://images.pexels.com/photos/16898979/pexels-photo-16898979.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "hochdruckreinigung",
    title: "Hochdruckreinigung",
    icon: Droplets,
    text: "Effektive Entfernung von hartnäckigen Verschmutzungen auf Fassaden, Terrassen und Wegen mit modernster Technik.",
    image:
      "https://images.pexels.com/photos/14965464/pexels-photo-14965464.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "dachrinnenreinigung",
    title: "Dachrinnenreinigung",
    icon: Waves,
    text: "Wir bieten Ihnen eine professionelle Dachrinnenreinigung, um Wasserschäden durch verstopfte Rinnen zu vermeiden.",
    image:
      "https://images.unsplash.com/photo-1744044155829-610dded4cead?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "gebaeudereinigung",
    title: "Gebäudereinigung",
    icon: Building2,
    text: "Umfassende Reinigung von Privathaushalten bis hin zu gewerblichen Gebäuden – immer mit höchster Sorgfalt.",
    image:
      "https://images.pexels.com/photos/6794970/pexels-photo-6794970.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "professionelle-reinigung",
    title: "Professionelle Reinigung",
    icon: ShieldCheck,
    text: "Unser erfahrenes Team sorgt für eine gründliche und zuverlässige Reinigung, die höchsten Standards entspricht.",
    image:
      "https://images.pexels.com/photos/9300768/pexels-photo-9300768.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "gartenpflege",
    title: "Gartenpflege",
    icon: Leaf,
    text: "Individuelle Gartenpflege-Dienste: Präzise abgestimmt auf Ihre Bedürfnisse und Wünsche für einen gepflegten Garten.",
    image:
      "https://images.pexels.com/photos/32427439/pexels-photo-32427439.jpeg?auto=compress&cs=tinysrgb&w=1200",
  },
  {
    id: "parkettboden",
    title: "Parkett & Bodenversiegelung",
    icon: Layers,
    text: "Professionelle Reinigung, Aufbereitung und PU-Versiegelung von Parkett- und Holzböden – für langanhaltenden Glanz und Schutz.",
    image:
      "https://customer-assets.emergentagent.com/job_service-kilic/artifacts/ad79hrgk_WhatsApp%20Image%202026-07-05%20at%2017.05.04.jpeg",
  },
];

export const SERVICE_OPTIONS = [
  "Glasreinigung",
  "Hochdruckreinigung",
  "Dachrinnenreinigung",
  "Gebäudereinigung",
  "Professionelle Reinigung",
  "Gartenpflege",
  "Parkett & Bodenversiegelung",
  "Sonstiges",
];

export const STATS = [
  { value: 20, suffix: "+", label: "Jahre Erfahrung" },
  { value: 100, suffix: "%", label: "Zufriedene Kunden" },
  { value: 6, suffix: "", label: "Leistungsbereiche" },
  { value: 24, suffix: "h", label: "Schnelle Rückmeldung" },
];

// ---- Kostenrechner (Angebots-Tool) ----
export const CALC_SERVICES = [
  { id: "Glasreinigung", label: "Glasreinigung", icon: Sparkles, base: 49, perUnit: 3.5, unit: "Fenster" },
  { id: "Fassaden-/Hochdruckreinigung", label: "Hochdruckreinigung", icon: Droplets, base: 89, perUnit: 4.5, unit: "m²" },
  { id: "Dachrinnenreinigung", label: "Dachrinnenreinigung", icon: Waves, base: 79, perUnit: 2.5, unit: "lfd. Meter" },
  { id: "Gebäudereinigung", label: "Gebäudereinigung", icon: Building2, base: 69, perUnit: 1.8, unit: "m²" },
  { id: "Gartenpflege", label: "Gartenpflege", icon: Leaf, base: 59, perUnit: 1.2, unit: "m²" },
  { id: "Parkett & Bodenversiegelung", label: "Parkett & Versiegelung", icon: Layers, base: 99, perUnit: 6, unit: "m²" },
];

export const CALC_FREQUENCY = [
  { id: "einmalig", label: "Einmalig", factor: 1 },
  { id: "monatlich", label: "Monatlich", factor: 0.9 },
  { id: "woechentlich", label: "Wöchentlich", factor: 0.8 },
];

// Google Rezensionen – bitte durch echte Texte ersetzen
export const REVIEWS = [
  {
    name: "Michael S.",
    city: "Bremen",
    rating: 5,
    date: "vor 2 Wochen",
    text: "Absolut professionell und zuverlässig! Die Glasreinigung war perfekt. Sehr zu empfehlen.",
  },
  {
    name: "Sarah K.",
    city: "Bremen",
    rating: 5,
    date: "vor 1 Monat",
    text: "Kilic Gebäudeservice hat unsere Dachrinnen schnell und sauber gereinigt. Tolles Team!",
  },
  {
    name: "Thomas M.",
    city: "Delmenhorst",
    rating: 5,
    date: "vor 1 Monat",
    text: "Seit Jahren unser Partner für die Unterhaltsreinigung im Büro. Immer pünktlich und extrem gründlich.",
  },
  {
    name: "Lisa B.",
    city: "Bremen",
    rating: 5,
    date: "vor 2 Monaten",
    text: "Wir haben eine Grundreinigung nach der Renovierung gebucht. Das Ergebnis war makellos!",
  },
  {
    name: "Ahmet Y.",
    city: "Achim",
    rating: 5,
    date: "vor 3 Monaten",
    text: "Fassade per Hochdruck gereinigt – sieht aus wie neu. Faire Preise und top Beratung.",
  },
  {
    name: "Katrin H.",
    city: "Bremen",
    rating: 5,
    date: "vor 3 Monaten",
    text: "Freundlich, schnell und sehr gründlich. Genau so stellt man sich guten Service vor.",
  },
];

export const GOOGLE_REVIEW_URL = "https://www.google.com/search?sca_esv=2d46150f081de832&hl=de-DE&q=Kilic+Geb%C3%A4udeservice&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_zka1IeVuXMtzrJmT65wMkhaaHRgOOGWf7ir7B9R3dk2oZN6lwIJpH_UosVouLfnhAwj-Cg%3D&sa=X";

export const buildWhatsAppLink = ({ name, service, message }) => {
  const lines = [
    "Hallo Kilic Gebäudeservice,",
    "",
    `ich interessiere mich für: ${service || "eine Reinigung"}.`,
  ];
  if (message) lines.push("", message);
  if (name) lines.push("", `Name: ${name}`);
  const text = encodeURIComponent(lines.join("\n"));
  return `https://wa.me/${COMPANY.whatsapp}?text=${text}`;
};
